import { FC } from 'react';
import { Address } from '../models/sites-models';

const AddressView: FC<{address: Address | undefined}> = ({ address }) => (
    <span>
        {[address?.region ? address.region : 'NotFound', address?.state ? address?.state : 'NotFound', address?.country ? address?.country : 'NotFound']
            .filter(x => !!x).join(", ")}
    </span>
);

export default AddressView;
